// extracted by mini-css-extract-plugin
module.exports = {"LogoImageContainer":"Logo_LogoImageContainer__qIVQl","LogoImage":"Logo_LogoImage__2leiy"};